import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { injectReducer } from "store/reducers";
import ViewUnitPlan from "./routes/ViewUnitPlan";
import EditUnitPlan from "./routes/EditUnitPlan";
import IBPlanner from "./routes/IBPlanner";
import { AssessmentDetails } from "Assessments";
import { LeDetails } from "LearningEngagement";
import { getRelativePath } from "Utils";
import Evidence from "Evidence";
import Insights from "Insights";
import UnitComments from "UnitComments";
import UnitFlowV3 from "UnitPlanDetails/routes/EditUnitPlan/routes/UnitFlowV3";
import { isSinglePageEnabled } from "UnitPlans/modules/UnitViewModeUtils";
import { getUnitFlowUtils } from "UnitFlowV3/modules/utils";
import { getIsUnitFlowRightPaneEnabled } from "Utils/ACLStoreUtils";

export default store => {
  return {
    path: ":unit_id",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unit-planner" */ "./components"),
          import(
            /* webpackChunkName: "unit-planner" */ "UnitLibrary/modules/UnitLibraryModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "UnitPlans/modules/UnitPlanModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "IBPlanner/modules/IBPlannerModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "Assessments/modules/AssessmentModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "LearningEngagement/modules/LeModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "CombinedLibrary/modules/CombinedLibraryModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "UnitPlanDetails/components/RightPane/UnitFlow/modules/UnitFlowModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "UnitFlowV3/modules/UnitFlowModule"
          ),
        ]).then(
          ([
            importedModule0,
            importedModule1,
            importedModule2,
            importedModule3,
            importedModule4,
            importedModule5,
            importedModule6,
            importedModule7,
            importedModule8,
            importedModule9,
            importedModule10,
          ]) => {
            const component = importedModule0.default;
            const unitLibraryReducer = importedModule1.default;
            const reducer = importedModule2.default;
            const plannerReducer = importedModule3.default;
            const assessmentReducer = importedModule4;
            const leReducer = importedModule5;
            const multiLevelNodeEditorReducer = importedModule6;
            injectReducer(store, {
              key: "unitLibrary",
              reducer: unitLibraryReducer,
            });
            injectReducer(store, {
              key: "unitPlans",
              reducer,
            });
            injectReducer(store, {
              key: "planner",
              reducer: plannerReducer,
            });
            injectReducer(store, {
              key: assessmentReducer.NAME,
              reducer: assessmentReducer.default,
            });
            injectReducer(store, {
              key: leReducer.NAME,
              reducer: leReducer.default,
            });
            injectReducer(store, {
              key: "multiLevelNodeEditor",
              reducer: multiLevelNodeEditorReducer.default,
            });
            injectReducer(store, {
              key: "combinedLibrary",
              reducer: importedModule7.default,
            });
            const { isUnitFlowRevampEnabled } = getUnitFlowUtils();
            const _isUnitFlowRevampEnabled = isUnitFlowRevampEnabled();
            if (_isUnitFlowRevampEnabled) {
              injectReducer(store, {
                key: "importFromUnitFlow",
                reducer: importedModule8.default,
              });
              injectReducer(store, {
                key: "unitFlow",
                reducer: importedModule10.default,
              });
            }
            if (getIsUnitFlowRightPaneEnabled()) {
              injectReducer(store, {
                key: "rightPaneUnitFlow",
                reducer: importedModule9.default,
              });
            }
            return withDynamicUrlValidation({
              component,
              urlValidationType: "number",
            });
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    async onEnter(nextState, replace) {
      if (_.last(nextState.routes).path == ":unit_id") {
        if (!(await isSinglePageEnabled())) {
          replace(getRelativePath("edit"));
        }
      }
    },
    childRoutes: [
      ViewUnitPlan(store),
      EditUnitPlan(store),
      AssessmentDetails(store),
      LeDetails(store),
      Insights(store),
      Evidence(store),
      UnitComments(store),
      UnitFlowV3(store),
      IBPlanner(store),
    ],
  };
};
